import React from 'react'

/**
 * @typedef {{ slug: string, title: string, subTypes?: RoomType[] }} RoomType
 * @arg {RoomType[]} types
 * @arg {string[]} selectedTypes
 */
const lodgingTypeToName = (roomTypes, selectedTypes) => {
  const roomType = roomTypes.find(type => type.slug === selectedTypes[0])
  return roomType?.subTypes
    ? [ roomType.title.replace(/ - .+/, ''), ...lodgingTypeToName(roomType.subTypes, selectedTypes.slice(1)) ]
    : [ (roomType?.title || '').replace(/ - .+/, '') ]
}

export default {
  eventId: 'ga2025',
  isClosed: true,
  dev: process.env.NODE_ENV === 'development',
  // process.env.REACT_APP_REGISTRATION_OPEN !== 'true' &&
  // process.env.NODE_ENV !== 'development',
  contacts: {
    registrationNotifications: [
      { email: 'cpcchurches@outlook.com' },
    ],
  },
  modules: {
  },

  // ageRanges are used in the attendees module, and ga2024 didn't use the attendees module
  // but it might have been be better if it did.
  // earlyArrival: '2024-05-13',
  dateRange: ['2025-05-20', '2025-05-23'],
  locationName: 'Camp McDowell (Alabama)',
  paymentConfig: {
    stripe: {
      apiKey: process.env.NODE_ENV === 'production' && process.env.REACT_APP_STAGING !== 'true'
        ? 'pk_live_51OeO9YFXzXnAkonKfYgxqHQOBJDpaOSfyCfHqr79DSZ1H3WV78qyLZAXowi9dhPEmludzrBYK4p6xzBInwClOHb500z5iDxrFd' // cpcchurches@outlook.com live account
        : 'pk_test_ST78pNT2kCrbsEbur8rrXxXS', // josephdykstra@gmail.com test account
    },
    // check: {
    //   attn: 'Dominion Covenant Church',
    //   address: [
    //     'Dominion Covenant Church',
    //     '5858 Wenninghoff Rd, #8',
    //     'Omaha, NE 68134-1911',
    //   ],
    // },
  },
  adminColumns: [
  ],
}
